import React from 'react';
import { Button, Tag } from 'carbon-components-react';
import { ChevronRight24 } from '@carbon/icons-react';
import { useHistory } from 'react-router-dom';

export type FeatureCardProps = {
  title: string;
  description: string;
  tags: string[];
  ctaLabel: string;
  to: string;
  icon: React.ReactNode;
  iconModifierClass: string;
};

const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  tags,
  ctaLabel,
  to,
  icon,
  iconModifierClass
}) => {
  const history = useHistory();

  const handleNavigate = () => {
    history.push(to);
  };

  return (
    <article className="premium-self-service__feature-card">
      <div className="premium-self-service__feature-card-content">
        <div
          className={`premium-self-service__feature-card-icon ${iconModifierClass}`}
        >
          {icon}
        </div>
        <div>
          <h2 className="premium-self-service__feature-card-title">{title}</h2>
          <p className="premium-self-service__feature-card-description">
            {description}
          </p>
        </div>
      </div>
      <div className="premium-self-service__feature-card-tags">
        {tags.map((tag) => (
          <Tag key={tag} type="gray">
            {tag}
          </Tag>
        ))}
      </div>
      <div className="premium-self-service__feature-card-divider"></div>
      <Button
        kind="ghost"
        className="premium-self-service__feature-card-cta"
        onClick={handleNavigate}
      >
        {ctaLabel}
        <ChevronRight24 style={{ paddingLeft: '8px' }} />
      </Button>
    </article>
  );
};

export default React.memo(FeatureCard);
